<template>
  <div>
    <header>
      <div class="left">
        <h2>Project Templates</h2>
        <p>Manage pre-made templates for new projects</p>
      </div>

      <div class="right">
        <a class="main-action" @click="showProjectTemplateModal = true">New Template</a>
      </div>
    </header>
    <div>
      <div class="flex-between">
        <search-box :onChange="(val) => (searchQuery = val)" />
      </div>

      <div v-if="loading" class="saving" style="margin-top: 70px;">
        <img src="~@/assets/icons/spinner.svg" />
        <p>Loading</p>
      </div>
      <table v-else-if="filteredTemplates.length" class="acada-table">
        <colgroup>
          <col style="width: 250px" />
          <col style="width: 40%" />
          <col style="width: 20%" />
          <col style="width: 20%" />
        </colgroup>

        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Stages</th>
          <th>Tasks</th>
        </tr>

        <tr
          v-for="template of filteredTemplates"
          :key="template.id"
          @click="$router.push({ name: 'ProjectTemplatesDetail', params: { id: template.id } });"
        >

          <td>{{ template.title }}</td>

          <td>{{ template.description }}</td>

          <td>{{ `${template.actionGroups.length} stages` }}</td>

          <td>{{ `${template.actionGroups.reduce((c, actionGroup) => (c + (actionGroup.actions.length || 0)), 0)} tasks`  }}</td>
        </tr>
      </table>

      <div v-else class="no-data">No templates to show</div>
    </div>

    <project-template-modal
        v-if="showProjectTemplateModal"
        mode="New"
        :template-id="-1"
        :onSave="createTemplate"
        @dismissed="showProjectTemplateModal = false"
    />

  </div>
</template>

<script>
import SearchBox from '../components/SearchBox';
import ProjectTemplateModal from '../components/ProjectTemplateModal';
import {mapGetters} from "vuex";
export default {
  name: "ProjectTemplates",
  components: {
    SearchBox,
    ProjectTemplateModal
  },
  mounted(){
    this.refreshTemplates()
  },
  data: () => ({
    searchQuery: '',
    loading: false,
    showProjectTemplateModal: false
  }),
  methods: {
    async refreshTemplates(){
      this.loading = true
      try {
        await this.$store.dispatch('getProjectTemplates');
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
      }
    },
    async createTemplate(template){
      await this.$store.dispatch('createProjectTemplate', template);
      // await this.refreshTemplates()
    }
  },
  computed: {
    ...mapGetters(['projectTemplates']),
    filteredTemplates(){
      let searchQuery = this.searchQuery ? this.searchQuery.toLowerCase() : '';
      return this.projectTemplates.filter((template) =>
        searchQuery === ''
          ? true
          : template.name.toLowerCase().includes(searchQuery)
      );
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.no-data {
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin: 30px 0;
  color: $sidebar-color;
  opacity: 0.5;
}

.saving {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;

  img {
    width: 40px;
    height: 40px;
    animation: spin 1.5s linear infinite;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    color: #565b64;
    margin: 5px 0 30px;
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
